<template>
    <div id="config-panel">
        <div class="type-list">
            <div :class="{item:true, active:menu.value === activeTab}" v-for="menu in menus" @click.stop="activeTab=menu.value">
                <i class="el-icon-menu"></i>
                <div>{{menu.name}}</div>
            </div>
        </div>
        <div class="panel-content">
            <template v-if="activeTab==='size'">
                <div class="form-field">
                    <label>宽度</label>
                    <div class="content">
                        <el-input type="number" size="mini" :value="output.width" @input="updateAttr('width', $event)"/>
                    </div>
                </div>
                <div class="form-field">
                    <label>高度</label>
                    <div class="content">
                        <el-input type="number" size="mini" :value="output.height" @input="updateAttr('height', $event)"/>
                    </div>
                </div>
                <div class="form-field">
                    <label>背景色</label>
                    <div class="content">
                        <el-color-picker show-alpha :value="output.bgColor" @input="updateAttr('bgColor', $event)"/>
                    </div>
                </div>
            </template>
            <template v-else="activeTab==='music'">
                <div class="form-field">
                    <label>背景音乐</label>
                    <div class="content">
                        <upload-audio :value="resource['##bgmusic']" @input="updateResource($event)"/>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
	export default {
		name: "ConfigPanel",
        data(){
			return {
				activeTab: "size",
				menus:[
                    {
                    	name: "输出",
                        value: "size"
                    },
					{
						name: "音乐",
						value: "music"
					}
                ]
            }
        },
        computed:{
			output(){
				return this.$store.state.outputDesc||{}
			},
			resource(){
				return this.$store.state.resource||{}
			}
        },
        methods:{
			updateAttr(key, value){
				console.log(value)
				this.$store.commit('update',{
					outputDesc: {
						...this.$store.state.outputDesc,
                        [key]:key==='bgColor'?value:+value
					},
                    ...(key === 'width'?{designWidth:+value}:null),
					...(key === 'height'?{designHeight:+value}:null)
				})
            },
			updateResource(value){
				this.$store.commit('update_resource',{
					['##bgmusic']:value
				})
            }
        }
	}
</script>

<style scoped lang="scss">
    #config-panel{
        display: flex;
    }
    .type-list{
        width:50px;
        height:100%;
        flex:none;
        border-right:1px solid #CCC;
        >.item{
            cursor:pointer;
            height:50px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            >div{
                font-size:12px;
            }
            &.active{
                color:#41b883;
            }
        }
    }
    .panel-content{
        flex:auto;
        padding: 0 10px;
    }
</style>
